const controller = function(
	$filter,
	$ionicHistory,
	$ionicLoading,
	$ionicModal,
	$ionicScrollDelegate,
	$ionicViewSwitcher,
	$rootScope,
	$scope,
	$state,
	$stateParams,
	$timeout,
	Product,
) {
	"ngInject";

	var vm = this;

	vm.showTitle = false;
	vm.showImage = false;

	vm.variations = [{
		uid: null,
		display: $filter('ucfirst')($filter('translate')('choose_variant'))+'...'
	}];
	vm.variation = vm.variations[0];

	function initialize() {

		$ionicLoading.show({
			noBackdrop: true
		});

		Product.log({
			product_id:$stateParams.uid,
			query:$stateParams.query,
			ref:$stateParams.ref
		});

		Product.get($stateParams.uid, {include:'images,specifications,similar,variations,brand'}).then(function(res) {

			if(res.icecat && res.icecat.specifications && res.icecat.specifications.length > 0) {
				vm.activeTab = 'specs';
			} else {
				vm.activeTab = 'description';
			}

			vm.product = res;
			if (vm.product.variations && vm.product.variations.length > 0) {
				vm.variations = vm.variations.concat(vm.product.variations);
			}

		}).finally(function() {
			$ionicLoading.hide();
		});
	}

	$scope.$on('$ionicView.loaded', function(e, data) {
		initialize();
	})

	var backView = $ionicHistory.backView();
	vm.hasHistory = backView && (backView.stateName !== 'tab.home');

	vm.back = function() {
		$ionicViewSwitcher.nextDirection('back');
		$ionicHistory.nextViewOptions({
			disableBack: true,
		    historyRoot: true
		});
		if ($ionicHistory.backView()) {
			$ionicHistory.backView().go();
		} else {
			$state.go('tab.search');
		}
		
	}

	vm.feedback = function() {
		$ionicHistory.nextViewOptions({
			disableBack: true,
		    historyRoot: true
		});
		$state.go('tab.support', { product: vm.product.id });
	}

	vm.changeVariation = function() {
		if (vm.variation.uid !== null) {
			$ionicHistory.nextViewOptions({
				disableAnimate: true,
				disableBack: true
			});
			$state.go('tab.product', { uid: vm.variation.uid, ref: 'variation' });
		}
	}

	vm.focusTab = function(tabname){
		vm.activeTab = tabname;
		$ionicScrollDelegate.resize();
		$timeout(function() {
			$ionicScrollDelegate.$getByHandle('product').scrollTo(0, 540, true);
		}, 200);
		
	};

	vm.getScrollPosition = function() {
		var tempShowImage = $ionicScrollDelegate.$getByHandle('product').getScrollPosition().top > 380;
		if (tempShowImage !== vm.showImage) {
			vm.showImage = tempShowImage;
			$scope.$apply();
		}
		var tempShowTitle = $ionicScrollDelegate.$getByHandle('product').getScrollPosition().top > 100;
		if (tempShowTitle !== vm.showTitle) {
			vm.showTitle = tempShowTitle;
			$scope.$apply();
		}
	}
}

export default controller;


// WEBPACK FOOTER //
// ./app/components/product/product.controller.js